"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardMedia.default;
  }
});

var _CardMedia = _interopRequireDefault(require("./CardMedia"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/CardMedia/index.js
// module id = 456
// module chunks = 0